// Small render helpers — no framework. `h` builds elements; `stub` renders the
// Phase-1 module placeholder from a registry entry.
import { HEX_MARK } from './icons.js'

/** Escape untrusted text before injecting into innerHTML. */
export function esc(s) {
  return String(s ?? '').replace(/[&<>"']/g, c => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
  ))
}

/** Set innerHTML and return the container (trusted template strings only). */
export function html(el, markup) { el.innerHTML = markup; return el }

const STATUS_BADGE = {
  live:     '<span class="badge ok">Live</span>',
  soon:     '<span class="badge soon">Phase 1 · shell</span>',
  deferred: '<span class="badge warn">Deferred</span>',
}

/** Render a module placeholder describing its scope. */
export function stub(el, m) {
  el.innerHTML = `
    <div class="stub">
      <div>
        <div class="hexwrap">${HEX_MARK}</div>
        <div class="role">${esc(m.role)}</div>
        <h2>${esc(m.title)} ${STATUS_BADGE[m.status] || ''}</h2>
        <p>${esc(m.sub)}</p>
        <ul class="plan">
          ${m.plan.map(p => `<li><b>›</b><span>${esc(p)}</span></li>`).join('')}
        </ul>
      </div>
    </div>`
}
